import {connect} from 'react-redux';
import axios  from 'axios';

import ListOperatorApplyScreen from "../ListOperatorApplyScreen";
import store from "../../../../../redux/store";
import {typeExport} from "../../../../../redux/store/type";
import {Tools} from "../../../../../tools/Tools";
var token_cancel=null;
//const controller = new AbortController();

//let source = axios.CancelToken.source();

const mapStateToProps = (state) => ({
    // item_count: state.reducerSplashGetAllData.results.item_count,
    results: state.reducerListOperatorApplyScreen.results,
    resultAll: state.reducerListOperatorApplyScreen.resultAll,
    NoInternetDialog: state.reducerListOperatorApplyScreen.NoInternetDialog,
    showLoading: state.reducerListOperatorApplyScreen.showLoading,
    lazyload_end: state.reducerListOperatorApplyScreen.lazyload_end,
    showRefresh: state.reducerListOperatorApplyScreen.showRefresh,
    failed: state.reducerListOperatorApplyScreen.failed,
    page: state.reducerListOperatorApplyScreen.page,
    empty: state.reducerListOperatorApplyScreen.empty,
    DataSplashScreen: state.reducerSplashGetAllData,
    resultsSet: state.reducerListOperatorApplyScreen.resultsSet,
    isLoadingSet: state.reducerListOperatorApplyScreen.isLoadingSet,
    NoInternetDialogSet: state.reducerListOperatorApplyScreen.NoInternetDialogSet,
    ListFilter: state.reducerListOperatorApplyScreen.ListFilter,
    ListSend: state.reducerListOperatorApplyScreen.ListSend,
    id: state.reducerListOperatorApplyScreen.id,
    // isLoadingSetSubmitRequestScreen: state.reducerSubmitRequestScreen.isLoadingSet,
});

const mapDispatchToProps = (dispatch, getState) => ({
    callService: (url, params, type, typeConnection, page, item_count, id) => dispatch(callWebservice(getState, url, params, type, typeConnection, page, item_count, id)),
    callServiceAddFirst: (data, item_count) => dispatch(serviceActionAddFirstData(data, item_count)),
    callServiceChangeNotif: (data) => dispatch(serviceActionChangeNotif(data)),
    callserviceActionRefresh: () => dispatch(serviceActionRefresh()),
    callserviceActionListFilter: (data) => dispatch(serviceActionListFilter(data)),
    // callServiceSuccess: (data,page) => dispatch(serviceActionSuccess(data,page)),

})

const getDataDisatch = (dispatch, getState, url, params, type, typeConnection, page, item_count, id) => {
    //source = axios.CancelToken.source();

    let pagee;
    let url_send = "";

    switch (type) {
        case typeExport.TypeGetListOperatorApplyScreen:
            url_send = typeExport.baseUrl + url + params + `&i=${page}`;
           // console.log("@@@@@@@@111",controller)

            if (page === 1) {
               //  if (source) {
               // //     console.log("@@@@@@@@")
               //     // controller.abort()
               //          // source.cancel("Landing Component got unmounted");
               //  }
                dispatch(serviceActionRefresh());

            } else dispatch(serviceActionPending());

            break;
        case typeExport.TypeSetListOperatorApplyScreen:
            url_send = typeExport.baseUrl + url + params;
            dispatch(serviceActionPendingSet(id))
            break;
        default:
    }

    let formData = new FormData();
    formData.append('_operation', params._operation);
    // // formData.append('lang', params.lang);
    formData.append('mode', params.mode);
    formData.append('token_mahale', params.token_mahale);
    formData.append('_session', store.getState().reducerSplashGetAllData.token == null ? '' : store.getState().reducerSplashGetAllData.token);
    formData.append('page', params.page);
    formData.append('type', params.type);
    formData.append('listFilter', JSON.stringify(params.listFilter));
    formData.append('extra', JSON.stringify(params.extra));
    formData.append('trackingCode', params.trackingCode);
    formData.append('mode_type', params.mode_type);
    Tools.addAllFormData(formData, true);


    //const { CancelToken } = axios;
    const config = {
        headers: {
            "Content-Type": "multipart/form-data; charset=utf-8;",
            timeout: typeExport._TIMEOUT,
          //  cancelToken: source.token,
          //   cancelToken: new CancelToken(function executor(cancellableFn) {
          //       token_cancel = cancellableFn;
          //   }),
        }
    };

    axios.post(url, formData, config)
        .then(async response => {
            let result = response.data.result;
            switch (type) {

                case typeExport.TypeGetListOperatorApplyScreen:


                    if (response.data.success) {


                        let data = result.list;
                        dispatch(serviceActionListFilter(result.searchItems));


                        let priority = result.priority;

                        /*      priority[0].units[0].units = [
                                  {
                                      id: "2",
                                      name: "دوم(مناطق)111",
                                      units: [
                                          {
                                              id: "2",
                                              name: "دوم(مناطق) 22"
                                          }
                                      ]
                                  }
                              ];*/


                        dispatch(serviceActionListSend(priority));

                        if (data == null) data = []
                        let arr = store.getState().reducerListOperatorApplyScreen.results
                        if (page == 1) {
                            arr = data
                            global.list_menu_shahrdar = result.menu
                        } else {
                            if (arr.length > 0)
                            //    arr.push(data);
                                arr = [...arr, ...data]
                            else
                                arr = data
                        }

                        if (data.length == item_count) {
                            pagee = page + 1;
                            dispatch(serviceActionSuccess(result, data, pagee));
                        }

                        else {
                            (page === 1 & (data.length == 0)) ?
                                dispatch(serviceActionEmpty(page))
                                :
                                (pagee = page + 1, dispatch(serviceActionEnd(result, data, pagee)));
                        }


                        // let t=((getState === null || getState === undefined || getState === '') ? id : getState.route.params.data.type);
                        // await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListOperatorApply +  t, arr)
                        // if (page == 1)
                        //     await AsyngStorageClass.setAsyng(global.IdCity +typeExport.ListOperatorApplyFilter + t, result.searchItems)

                    } else {
                        dispatch(serviceActionError(response, page))

                        //alert(response.data.message)
                    }

                    break;

                case typeExport.TypeSetListOperatorApplyScreen:
                    if (response.data.status)
                        dispatch(serviceActionSuccessSet(response.data, id))
                    else
                        dispatch(serviceActionError(e, page))
                    //    alert(response.data.message)
                    break;
                default:
                    alert("")
            }
        }).catch((e) => {
        console.log("ahmad=> error", e)
        switch (type) {
            case typeExport.TypeGetListOperatorApplyScreen:
                dispatch(serviceActionError(e, page))

                break;
            case typeExport.TypeSetListOperatorApplyScreen:
                dispatch(serviceActionErrorSet(e))
                break;
            default:
        }
    })
}


export const callWebservice = (getState, url, params, type, typeConnection, page, item_count, id) => {

    return dispatch => {


        // NetInfo.getConnectionInfo().done(
        //     (isConnected) => {
        //         if (isConnected) {
        //             getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        //         } else {
        //             dispatch(serviceActionError("No Internet Connection", page));
        //
        //         }
        //     }
        // )

        if (store.getState().reducerSplashGetAllData.Connection) {
            getDataDisatch(dispatch, getState, url, params, type, typeConnection, page, item_count, id);
        } else {
            switch (type) {
                case typeExport.TypeGetListOperatorApplyScreen:
                    dispatch(serviceActionError('error_Connection', page))

                    break;
                case typeExport.TypeSetListOperatorApplyScreen:
                    dispatch(serviceActionErrorSet('error_Connection'))
                    break;
                default:
            }
        }


    }
}

export const serviceActionPendingSet = (id) => ({
    type: typeExport.SetListOperatorApplyScreen_SERVICE_PENDING,
    NoInternetDialogSet: false,
    isLoadingSet: true,
    resultsSet: null,
    id: id

})

export const serviceActionErrorSet = (error) => ({
    type: typeExport.SetListOperatorApplyScreen_SERVICE_ERROR,
    NoInternetDialogSet: true,
    isLoadingSet: false,
    error: error
})

export const serviceActionSuccessSet = (data, id) => ({
    type: typeExport.SetListOperatorApplyScreen_SERVICE_SUCCESS,
    NoInternetDialogSet: false,
    isLoadingSet: false,
    resultsSet: data,
    id: id,
})
export const serviceActionPending = () => ({
    type: typeExport.ListOperatorApplyScreen_SERVICE_PENDING,
    NoInternetDialog: false,
    showRefresh: false,
    showLoading: true,
    lazyload_end: false,
    empty: false,
    failed: false
})

export const serviceActionError = (error, page) => ({
    type: typeExport.ListOperatorApplyScreen_SERVICE_ERROR,
    NoInternetDialog: true,
    showRefresh: false,
    showLoading: false,
    lazyload_end: true,
    empty: false,
    failed: true,
    page: page,
    error: error
})
export const serviceActionRefresh = () => ({
    type: typeExport.ListOperatorApplyScreen_SERVICE_REFRESH,
    results: [],
    NoInternetDialog: false,
    showRefresh: true,
    lazyload_end: false,
    showLoading: false,
    empty: false,
    failed: false,
    page: 1,

})
export const serviceActionSuccess = (result, data, page) => ({

    type: typeExport.ListOperatorApplyScreen_SERVICE_SUCCESS,
    NoInternetDialog: false,
    resultAll: result,
    results: data,
    //  resultsFavourite: data,
    showRefresh: false,
    lazyload_end: false,
    showLoading: true,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEnd = (result, data, page) => ({
    type: typeExport.ListOperatorApplyScreen_SERVICE_END,
    resultAll: result,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: false,
    failed: false,
    page: page
})
export const serviceActionEmpty = (page) => ({
    type: typeExport.ListOperatorApplyScreen_SERVICE_Empty,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: true,
    showLoading: false,
    empty: true,
    failed: false,
    page: page
})
export const serviceActionAddFirstData = (data, item_count) => ({
    type: typeExport.ListOperatorApplyScreen_SERVICE_ADD_FIRST_DATA,
    results: data,
    NoInternetDialog: false,
    showRefresh: false,
    lazyload_end: (data.length < item_count) ? true : false,
    showLoading: false,
    empty: data.length == 0 ? true : false,
    failed: false,
    page: 2
})

export const serviceActionChangeNotif = (data) => ({
    type: typeExport.ListOperatorApplyScreen_SERVICE_CHANGE_NOTIF,

    data: data
})
export const serviceActionAddSubList = (data) => ({

    type: typeExport.ListOperatorApplyScreen_SERVICE_AddSubList,

    data: data,

})

export const serviceActionListFilter = (data) => ({

    type: typeExport.ListOperatorApplyScreen_SERVICE_LIST_FILTER,

    ListFilter: data,

})
export const serviceActionListSend = (data) => ({

    type: typeExport.ListOperatorApplyScreen_SERVICE_LIST_Send,

    ListSend: data,

})
export const serviceActionAddComment = (data, index) => ({

    type: typeExport.ListOperatorApplyScreen_SERVICE_ADD_COMMENT,

    index: index,
    data: data,

})
export default connect(mapStateToProps, mapDispatchToProps)(ListOperatorApplyScreen);
